import { useEffect, useState } from "react";
import { Check, Copy } from "lucide-react";
import { toast } from "sonner";
import { api, formatError } from "@/lib/api";

export const PromptEditor = ({ analysisId, prompt, streaming, onSaved }) => {
  const [value, setValue] = useState(prompt);
  const [saving, setSaving] = useState(false);
  useEffect(() => setValue(prompt), [prompt]);
  const dirty = value !== prompt;

  const copy = async () => {
    await navigator.clipboard.writeText(value);
    toast.success("Prompt copiato");
  };

  const save = async () => {
    setSaving(true);
    try {
      await api.patch(`/analyses/${analysisId}`, { prompt: value });
      onSaved(value);
      toast.success("Prompt salvato nello storico");
    } catch (e) {
      toast.error(formatError(e));
    } finally {
      setSaving(false);
    }
  };

  if (streaming) {
    return <p className="rf-mono text-sm leading-relaxed rf-caret" data-testid="reconstructed-prompt-streaming">{prompt}</p>;
  }

  return (
    <div className="space-y-4">
      <textarea
        value={value}
        onChange={(e) => setValue(e.target.value)}
        rows={Math.min(14, Math.max(5, Math.ceil(value.length / 80)))}
        className="w-full rf-mono text-sm leading-relaxed bg-[var(--rf-soft)] border border-transparent focus:border-[var(--rf-red)] outline-none p-5 resize-y transition-colors"
        data-testid="reconstructed-prompt-textarea"
      />
      <div className="flex flex-wrap gap-3">
        <button onClick={copy} className="rf-btn rf-btn-sm" data-testid="copy-reconstructed-prompt-button">
          <Copy size={13} /> Copia prompt
        </button>
        <button onClick={save} disabled={!dirty || saving} className="rf-btn rf-btn-ghost rf-btn-sm" data-testid="save-reconstructed-prompt-button">
          <Check size={13} /> {saving ? "Salvataggio…" : "Salva modifiche"}
        </button>
        {dirty && <span className="self-center text-xs rf-red rf-mono" data-testid="prompt-unsaved-indicator">modifiche non salvate</span>}
      </div>
    </div>
  );
};
